(function() {
  'use strict';

  angular.module('blocks.locationHelper', []);
})();
